import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { AddressApi } from '../../models/Address';
import { API_BUSINESS_URL } from '@/utils';

const addressesService = createApi({
  reducerPath: 'addressesService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}/address`),
  tagTypes: ['Addresses'],
  endpoints: (builder) => ({
    getAddresses: builder.query<
      PaginatedResponse<AddressApi>,
      { 
        search?: string; 
        neighborhoodId?: string;
        paginated: PaginatedRequest 
      }
    >({
      query: ({ search, neighborhoodId, paginated }) => {
        const params: any = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        };

        if (search && search.trim() !== '') {
          params.search = search.trim();
        }

        if (neighborhoodId) {
          params.neighborhoodId = neighborhoodId;
        }

        return {
          url: '',
          params,
        };
      },
      providesTags: ['Addresses'],
    }),
    
    getAddressById: builder.query<AddressApi, { addressId: string }>({
      query: ({ addressId }) => ({
        url: `/${addressId}`,
        params: {
          include:
            'neighborhood,neighborhood.city,neighborhood.city.stateOrDepartment',
        },
      }),
      providesTags: ['Addresses'],
    }),

    createAddress: builder.mutation<AddressApi, Partial<AddressApi>>({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Addresses'],
    }),

    updateAddress: builder.mutation<
      AddressApi,
      { addressId: string; body: Partial<AddressApi> }
    >({
      query: ({ addressId, body }) => ({
        url: `/${addressId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Addresses'],
    }),

    deleteAddress: builder.mutation<void, { addressId: string }>({
      query: ({ addressId }) => ({
        url: `/${addressId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Addresses'],
    }),
  }),
});

export default addressesService;

export const {
  useGetAddressesQuery,
  useGetAddressByIdQuery,
  useLazyGetAddressByIdQuery,
  useCreateAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
} = addressesService;




